module.exports = __webpack_public_path__ + "img/workspace-onboarding/create-folders-f1235e6d5f0a3aacd200196d898d49fe.png";